import { useEffect, useState } from "react";
import { useProyeccionDiaria } from "../hooks/useProyeccionDiaria";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SkeletonTable } from "../../../components/Skeleton.Table";
import Swal from "sweetalert2";
import { usePedidoEmpaque } from "../hooks/usePedidoEmpaque";

export const AsignarProgramacion = ({
  programacion,
  fecha,
  onClose,
  reload,
  isVisible,
}) => {
  const { getProyeccionDiaria } = useProyeccionDiaria();
  const { postPedidoEmpaque } = usePedidoEmpaque();
  const [diaria, setDiaria] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [asignacion, setAsignacion] = useState([]);

  const handleAsignacionChange = (id_diaria, cantidad, proyeccion) => {
    const nuevaCantidad = cantidad === "" ? "" : Number(cantidad);
    const totalPermitido = programacion?.cantidad * programacion?.estiba;
    const asignacion_data = [...asignacion];

    const index = asignacion.findIndex((item) => item.id_diaria === id_diaria);

    let sumaTotal = asignacion.reduce((acc, item, idx) => {
      if (idx === index) {
        return (
          acc + (nuevaCantidad === "" ? 0 : nuevaCantidad * programacion.estiba)
        );
      }
      return (
        acc + (item.cantidad === "" ? 0 : item.cantidad * programacion.estiba)
      );
    }, 0);

    if (index === -1) {
      sumaTotal +=
        nuevaCantidad === "" ? 0 : nuevaCantidad * programacion.estiba;
    }

    const cantidadFinal =
      sumaTotal > totalPermitido ||
      proyeccion <
        (nuevaCantidad === "" ? 0 : nuevaCantidad * programacion.estiba)
        ? 0
        : nuevaCantidad;

    if (index > -1) {
      asignacion_data[index].cantidad = cantidadFinal;
    } else {
      const data = {
        id_diaria,
        cantidad: cantidadFinal,
      };
      if (totalPermitido) asignacion_data.push(data);
    }

    setAsignacion(asignacion_data);
  };

  const handleClose = () => {
    setDiaria([]);
    onClose();
  };

  const handleAsignar = async (id_diaria) => {
    Swal.fire({
      title: "Asignando...",
      text: "Por favor espere",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      await postPedidoEmpaque(
        [{ id_diaria, cantidad: programacion.cantidad }],
        programacion.id
      );
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "¡Asignación exitosa!",
        timer: 1500,
        showConfirmButton: false,
      });
      reload();
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error al asignar",
        text: error?.message || "Ocurrió un error inesperado",
      });
    }
  };

  const handleAceptarAsignacion = async () => {
    if (asignacion.length > 0) {
      const total =
        asignacion.reduce((sum, item) => sum + item.cantidad, 0) *
        programacion.estiba;

      if (total === programacion.cantidad * programacion.estiba) {
        Swal.fire({
          title: "Asignando...",
          text: "Por favor espere",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          await postPedidoEmpaque(asignacion, programacion.id);
          Swal.close();
          Swal.fire({
            icon: "success",
            title: "¡Asignación exitosa!",
            timer: 1500,
            showConfirmButton: false,
          });
          reload();
        } catch (error) {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error al asignar",
            text: error?.message || "Ocurrió un error inesperado",
          });
        }
      }
    }
  };

  useEffect(() => {
    const getProyeccion = async () => {
      try {
        const response = await getProyeccionDiaria(
          fecha,
          programacion.id_variedad,
          programacion.color
        );
        console.log(response);
        setDiaria(response);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    getProyeccion();
  }, [fecha, getProyeccionDiaria, programacion]);

  return (
    <Modal isOpen={isVisible} toggle={handleClose} size="lg">
      <ModalHeader>
        Asignar programacion de empaque {programacion?.calibre}{" "}
        {programacion.cantidad} palets -{" "}
        {programacion?.cantidad * programacion?.estiba} cajas
      </ModalHeader>
      <ModalBody>
        {isLoading ? (
          <SkeletonTable />
        ) : (
          <div className="table-responsive">
            {diaria.map((campo) => (
              <table className="table" key={campo.id_campo}>
                <thead>
                  <tr>
                    <th>{campo.campo}</th>
                    <th>CALIBRE</th>
                    <th>PROYECCIÓN</th>
                    <th>CANTIDAD PALET</th>
                  </tr>
                </thead>
                <tbody>
                  {campo.variedades.map((variedad) => {
                    const currentSize = variedad.tamanos.find(
                      (size) => size.tamanio === programacion.calibre
                    );
                    return (
                      <tr key={variedad.id_diaria}>
                        <td>{variedad.variedad}</td>
                        <td>{currentSize?.tamanio}</td>
                        <td>{currentSize?.total}</td>
                        <td>
                          <input
                            className="form-control"
                            value={
                              asignacion.find(
                                (item) => item.id_diaria === variedad.id_diaria
                              )?.cantidad ?? ""
                            }
                            onChange={(e) =>
                              handleAsignacionChange(
                                variedad.id_diaria,
                                e.target.value,
                                currentSize?.total
                              )
                            }
                            type="number"
                          />
                          <label>
                            {displayTotal(
                              asignacion,
                              variedad.id_diaria,
                              programacion.estiba
                            )}
                          </label>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={
                              (currentSize &&
                                currentSize.total <
                                  programacion.cantidad *
                                    programacion.estiba) ||
                              asignacion.filter(
                                (item) =>
                                  item.cantidad > 0 && item.cantidad !== ""
                              ).length > 0
                            }
                            onClick={() => handleAsignar(variedad.id_diaria)}
                          >
                            ASIGNAR
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-danger" onClick={handleClose}>
          Cancelar
        </button>
        <button
          className="btn btn-success"
          disabled={
            asignacion.length === 0 ||
            asignacion.filter(
              (item) => item.cantidad !== 0 && item.cantidad !== ""
            ).length === 0
          }
          onClick={handleAceptarAsignacion}
        >
          Guardar
        </button>
      </ModalFooter>
    </Modal>
  );
};

const displayTotal = (asignacion, id_diaria, estiba) => {
  const current = asignacion.find((item) => item.id_diaria === id_diaria);
  if (current) {
    return current.cantidad * estiba;
  }
  return 0;
};
